module.exports = __webpack_public_path__ + "static/img/termsofuse.f7a1092c.jpg";